import React from 'react';
import { PageHeading, Heading, Text } from '../components/ui';

const DMCAPolicy = () => {
    return (
        <div className="min-h-screen bg-neutral-50 px-0">
            <div className="max-w-4xl mx-auto py-8 px-4">
                <PageHeading>DMCA Copyright Policy</PageHeading>
                
                <div className="bg-neutral-0 hairline minimal-padding mt-8 space-y-6">
                    <Text size="sm" className="text-neutral-900 opacity-60">
                        Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                    </Text>

                    <div>
                        <Text size="sm" className="text-neutral-900">
                            4RKED respects the intellectual property rights of others and expects our users to do the same. It is our policy to respond to clear notices of alleged copyright infringement that comply with the Digital Millennium Copyright Act ("DMCA").
                        </Text>
                    </div>

                    <div>
                        <Heading level={2} style={{ color: '#1b263b' }}>1. Reporting Copyright Infringement</Heading>
                        
                        <Text size="sm" className="text-neutral-900 mt-4">
                            If you are a copyright owner or an agent thereof and believe that content available on 4RKED infringes your copyright, you may submit a written notification to our designated DMCA agent.
                        </Text>
                        
                        <Text size="sm" className="text-neutral-900 mt-4 font-medium">
                            Your notification must include the following information (as required by 17 U.S.C. § 512(c)(3)):
                        </Text>
                        
                        <ol className="text-neutral-900 text-sm space-y-2 ml-4 list-decimal mt-2">
                            <li>A physical or electronic signature of the person authorized to act on behalf of the owner of the copyright.</li>
                            <li>Identification of the copyrighted work claimed to have been infringed, or a representative list if multiple works are covered by a single notification.</li>
                            <li>Identification of the material that is claimed to be infringing or the subject of infringing activity and that is to be removed or access to which is to be disabled, along with information reasonably sufficient to permit us to locate the material (e.g., URL of the content within 4RKED).</li>
                            <li>Your contact information, such as address, telephone number, and email address.</li>
                            <li>A statement that you have a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law.</li>
                            <li>A statement that the information in the notification is accurate and, under penalty of perjury, that you are authorized to act on behalf of the copyright owner.</li>
                        </ol>
                        
                        <div className="bg-neutral-50 p-4 hairline mt-4">
                            <Text size="sm" className="text-neutral-900 font-medium mb-2">
                                Please send DMCA notices to:
                            </Text>
                            <Text size="sm" className="text-neutral-900">
                                DMCA Agent<br />
                                4RKED<br />
                                Email: dmca@4rked.com<br />
                                Postal Address: [To be provided]
                            </Text>
                        </div>
                    </div>

                    <div>
                        <Heading level={2} style={{ color: '#1b263b' }}>2. Counter-Notification</Heading>
                        
                        <Text size="sm" className="text-neutral-900 mt-4">
                            If you believe that content removed or disabled as a result of a DMCA notice is not infringing, or that you have the authorization to use the content, you may send us a counter-notification containing the following information:
                        </Text>
                        
                        <ol className="text-neutral-900 text-sm space-y-2 ml-4 list-decimal mt-2">
                            <li>Your physical or electronic signature.</li>
                            <li>Identification of the content that has been removed or to which access has been disabled, and the location where the content appeared before it was removed or disabled.</li>
                            <li>A statement under penalty of perjury that you have a good faith belief that the content was removed or disabled as a result of mistake or misidentification.</li>
                            <li>Your name, address, telephone number, and email address, and a statement that you consent to the jurisdiction of the federal court in your judicial district (or, if outside the U.S., the federal courts located where 4RKED is located), and that you will accept service of process from the person who provided the original DMCA notice or their agent.</li>
                        </ol>
                        
                        <Text size="sm" className="text-neutral-900 mt-4">
                            Upon receipt of a valid counter-notification, we may restore the content in accordance with the DMCA, unless the original complainant files a court action seeking to restrain such use of the content.
                        </Text>
                    </div>

                    <div>
                        <Heading level={2} style={{ color: '#1b263b' }}>3. Repeat Infringers</Heading>
                        
                        <Text size="sm" className="text-neutral-900 mt-4">
                            In appropriate circumstances, it is our policy to terminate user accounts that are deemed to be repeat infringers.
                        </Text>
                    </div>

                    <div>
                        <Heading level={2} style={{ color: '#1b263b' }}>4. Misuse of the DMCA</Heading>
                        
                        <Text size="sm" className="text-neutral-900 mt-4">
                            Please note that under 17 U.S.C. § 512(f), any person who knowingly misrepresents that material or activity is infringing may be subject to liability for damages, including costs and attorneys' fees.
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DMCAPolicy;

